import React from 'react';
import ZipInputAlpha from './ZipInput.alpha';
import ZipInputLegacy from './ZipInput.legacy';

const ZipInput: React.FC = () => {
  const isAlpha = !process.env.IS_LEGACY;
  const Component = isAlpha ? ZipInputAlpha : ZipInputLegacy;
  return <Component />;
};

export default ZipInput;
